import { motion } from 'framer-motion';

export default function Hero() {
  return (
    <section className="relative h-screen w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/47507c7bf32c9edc6f314319925e0f95.jpg"
          alt="Happy family in their new home"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative h-full max-w-7xl mx-auto px-6 flex items-end pb-32">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="w-full max-w-2xl"
        >
          <div className="inline-block mb-6 px-4 py-2 rounded-full border-2 border-white/80 backdrop-blur-sm">
            <span className="text-white text-sm font-medium">Licensed Loan Officer</span>
          </div>
          
          <h1 className="font-serif mb-6">
            <div className="text-7xl text-white leading-tight">Your Home Financing</div>
            <div className="text-7xl text-white italic leading-tight">Partner for Life</div>
          </h1>
          
          <p className="text-xl text-white/90 mb-8 max-w-xl leading-relaxed">
            Helping families achieve their dream of homeownership with personalized service, competitive rates, and expert guidance every step of the way.
          </p>
          
          <div className="flex gap-4">
            <button className="bg-teal text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-teal/90 transition-all hover:scale-105 whitespace-nowrap cursor-pointer">
              Start Your Application
            </button>
            <button className="bg-white/20 backdrop-blur-sm text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-white/30 transition-all border-2 border-white/50 whitespace-nowrap cursor-pointer">
              Calculate Payment
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
}